import { convertHsvToRgb, serializeHex } from 'culori/fn';

export function socOffsetColor(offset: number): string {
  const clamped = Math.max(0, Math.min(0.3, Math.abs(offset)));
  const percent = clamped / 0.3;

  return serializeHex(
    convertHsvToRgb({
      h: 128 - percent * 128,
      s: 1,
      v: 0.8,
    }),
  );
}
